<script setup>
import {onMounted, ref, reactive, defineProps, watchEffect } from "vue";
const props = defineProps({
    direction: String
});
import Swal from "sweetalert2";
import axios from "axios";
import {backendSocket} from "../../sockets";
import { globalStore } from "../../stores";
import $ from "jquery";

const userId = $('meta[name="user-id"]').attr('content');
const wallets = reactive(pageData.wallets);
const market = pageData.market;
const fromCurrency = pageData.market.from_cgw_currency
const toCurrency = pageData.market.to_cgw_currency
const openingPosition = ref(false)

const fromCurrencyWallet = ref('0')
const toCurrencyWallet = ref('0')

const amountPlaceholder = ref('0')
const pricePlaceholder = ref('0')
const totalPlaceholder = ref('0')

globalStore.lastPrice = globalStore.buyPrice = globalStore.sellPrice = parseFloat(pageData.market.market_data.last_price).toFixed(market.price_decimals);

onMounted( () => {
    if (globalStore.userId) {
        backendSocket.private(`wallet.balance.${globalStore.userId}`).listen('.balance', ({ balance, currency }) => {
            if (wallets[currency]) {
                wallets[currency].balance = balance;
            }
        });
    }

    amountPlaceholder.value = (market.amount_decimals > 0 ? "0." : "0")  + "0".repeat(market.amount_decimals);
    pricePlaceholder.value = (market.price_decimals > 0 ? "0." : "0") + "0".repeat(market.price_decimals);
    totalPlaceholder.value = (market.total_decimals > 0 ? "0." : "0") + "0".repeat(market.total_decimals);
});

watchEffect(() => {
    if(wallets){
        fromCurrencyWallet.value = parseFloat(wallets[fromCurrency.slug].balance).toFixed(fromCurrency.decimals)
        toCurrencyWallet.value = parseFloat(wallets[toCurrency.slug].balance).toFixed(toCurrency.decimals)
    }else{
        fromCurrencyWallet.value = (fromCurrency.decimals > 0 ? "0." : "0") + "0".repeat(fromCurrency.decimals)
        toCurrencyWallet.value = (toCurrency.decimals > 0 ? "0." : "0") + "0".repeat(toCurrency.decimals)
    }
});

const openPosition = (direction) => {
    if (!globalStore.userId) {
        Swal.fire('Warning!', 'You are not logged in!', 'warning');
        return false;
    }

    const positionData = {
        market: pageData.market.id,
        direction,
        amount: direction === 'BUY' ? globalStore.buyAmount : globalStore.sellAmount,
        price: direction === 'BUY' ? globalStore.buyPrice : globalStore.sellPrice,
    };

    if (positionData.amount === 0 || positionData.price === 0) {
        Swal.fire('Warning!', 'Parameters not set!', 'warning');
        return false;
    }

    openingPosition.value = true

    axios.post("/exchange/open-position", positionData).then(r => {
        globalStore.buyAmount = 0;
        globalStore.sellAmount = 0;
        globalStore.buyTotal = 0;
        globalStore.sellTotal = 0;
    }).catch(({response:{data}}) => {
        Swal.fire('Warning!', data.message ?? data.data.message, 'warning');
    }).finally(() => {
        openingPosition.value = false;
    });
}

const numberToCryptoDecimals = (number, decimals = 8) => {
    return Math.floor(parseFloat(number) * 10 ** decimals) / 10 ** decimals;
}

const percentageClick = (percentage, type) => {
    switch (type) {
        case ('BUY'):
            globalStore.buyTotal = parseFloat((pageData.wallets ? pageData.wallets[pageData.market.to_cgw_currency.slug].balance : 0) * percentage).toFixed(pageData.market.total_decimals)
            calculate("BUY-TOTAL")
            break;
        case ('SELL'):
            globalStore.sellAmount = parseFloat((pageData.wallets ? pageData.wallets[pageData.market.from_cgw_currency.slug].balance : 0) * percentage).toFixed(pageData.market.amount_decimals)
            calculate("SELL-AMOUNT")
            break;
    }
}

const restrictDecimalsAndNumbers = (event, decimalPlaces, type) => {
    let decimalIndex = '';

    switch (type) {
        case ('BUY-AMOUNT'):
            globalStore.buyAmount = String(globalStore.buyAmount).replace(/[^\d.]/g, '');
            globalStore.buyAmount = String(globalStore.buyAmount).replace(/(\..*)\./g, '$1');

            decimalIndex = globalStore.buyAmount.indexOf('.');
            if (decimalIndex !== -1 && globalStore.buyAmount.substring(decimalIndex + 1).length > decimalPlaces) {
                globalStore.buyAmount = globalStore.buyAmount.substring(0, decimalIndex + decimalPlaces + 1);
            }
            break
        case ('BUY-TOTAL'):
            globalStore.buyTotal = String(globalStore.buyTotal).replace(/[^\d.]/g, '');
            globalStore.buyTotal = String(globalStore.buyTotal).replace(/(\..*)\./g, '$1');

            decimalIndex = globalStore.buyTotal.indexOf('.');
            if (decimalIndex !== -1 && globalStore.buyTotal.substring(decimalIndex + 1).length > decimalPlaces) {
                globalStore.buyTotal = globalStore.buyTotal.substring(0, decimalIndex + decimalPlaces + 1);
            }
            break
        case ('SELL-AMOUNT'):
            globalStore.sellAmount = String(globalStore.sellAmount).replace(/[^\d.]/g, '');
            globalStore.sellAmount = String(globalStore.sellAmount).replace(/(\..*)\./g, '$1');

            decimalIndex = globalStore.sellAmount.indexOf('.');
            if (decimalIndex !== -1 && globalStore.sellAmount.substring(decimalIndex + 1).length > decimalPlaces) {
                globalStore.sellAmount = globalStore.sellAmount.substring(0, decimalIndex + decimalPlaces + 1);
            }
            break
        case ('SELL-TOTAL'):
            globalStore.sellTotal = String(globalStore.sellTotal).replace(/[^\d.]/g, '');
            globalStore.sellTotal = String(globalStore.sellTotal).replace(/(\..*)\./g, '$1');

            decimalIndex = globalStore.sellTotal.indexOf('.');
            if (decimalIndex !== -1 && globalStore.sellTotal.substring(decimalIndex + 1).length > decimalPlaces) {
                globalStore.sellTotal = globalStore.sellTotal.substring(0, decimalIndex + decimalPlaces + 1);
            }
            break
        case('BUY-PRICE'):
            globalStore.buyPrice = String(globalStore.buyPrice).replace(/[^\d.]/g, '');
            globalStore.buyPrice = String(globalStore.buyPrice).replace(/(\..*)\./g, '$1');

            decimalIndex = globalStore.buyPrice.indexOf('.');
            if (decimalIndex !== -1 && globalStore.buyPrice.substring(decimalIndex + 1).length > decimalPlaces) {
                globalStore.buyPrice = globalStore.buyPrice.substring(0, decimalIndex + decimalPlaces + 1);
            }
            break
        case('SELL-PRICE'):
            globalStore.sellPrice = String(globalStore.sellPrice).replace(/[^\d.]/g, '');
            globalStore.sellPrice = String(globalStore.sellPrice).replace(/(\..*)\./g, '$1');

            decimalIndex = globalStore.sellPrice.indexOf('.');
            if (decimalIndex !== -1 && globalStore.sellPrice.substring(decimalIndex + 1).length > decimalPlaces) {
                globalStore.sellPrice = globalStore.sellPrice.substring(0, decimalIndex + decimalPlaces + 1);
            }
            break
    }

    calculate(type)
}

const calculate = (type) => {
    switch(type) {
        case ('BUY-AMOUNT'):
        case ('BUY-PRICE'):
            globalStore.buyTotal = numberToCryptoDecimals(globalStore.buyAmount * globalStore.buyPrice, market.total_decimals)
            break;
        case ('BUY-TOTAL'):
            globalStore.buyAmount = numberToCryptoDecimals(globalStore.buyTotal / globalStore.buyPrice, market.amount_decimals)
            break;
        case ('SELL-AMOUNT'):
        case ('SELL-PRICE'):
            globalStore.sellTotal = numberToCryptoDecimals(globalStore.sellAmount * globalStore.sellPrice, market.total_decimals)
            break;
        case ('SELL-TOTAL'):
            globalStore.sellAmount = numberToCryptoDecimals(globalStore.sellTotal / globalStore.sellPrice, market.amount_decimals)
            break;
    }
}

</script>
<template>
    <div v-if="direction === 'Buy'" class="flex flex-col justify-between h-full">
        <div class="flex-1 bg-white rounded-[15px] overflow-hidden pb-5">
            <div class="border-b border-[#eeeff2] py-3 px-5 mb-3 flex lg:flex-row flex-col items-center justify-between">
                <span class="block text-[20px] font-[CircularBook] text-center">
                    Buy {{ fromCurrency.slug }}
                </span>
                <div>
                    <span class="block text-[12px] text-[#366fed] text-center lg:text-right font-[CircularMedium]">
                        {{ toCurrencyWallet }} {{ toCurrency.slug }}
                    </span>
                    <span class="block text-[12px] text-[#a4a6aa] text-center lg:text-right">Available Balance</span>
                </div>
            </div>
            <div class="px-5 py-3 space-y-[10px]">
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-2 text-gray-900 border rounded-e-0 border-[#eeeff2] border-e-0 rounded-s-md">
                        {{ fromCurrency.slug }} Amount
                    </span>
                    <input
                        class="text-[#2a395a] rounded-none rounded-e-lg bg-white border text-right text-[12px] block flex-1 min-w-0 w-full text-sm border-[#eeeff2] p-1.5 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:text-right placeholder:font-[CircularBook]"
                        :placeholder="amountPlaceholder"
                        autocomplete="off"
                        type="text"
                        data-original-title="Amount"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Amount"
                        @keyup="restrictDecimalsAndNumbers($event, market.amount_decimals, 'BUY-AMOUNT')"
                        v-model="globalStore.buyAmount"
                    >
                </div>
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-2 text-gray-900 border rounded-e-0 border-[#eeeff2] border-e-0 rounded-s-md">
                        {{ toCurrency.slug }} Price
                    </span>
                    <input
                        class="text-[#2a395a] rounded-none rounded-e-lg bg-white border text-right text-[12px] block flex-1 min-w-0 w-full text-sm border-[#eeeff2] p-1.5 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:text-right placeholder:font-[CircularBook]"
                        :placeholder="pricePlaceholder"
                        autocomplete="off"
                        type="text"
                        data-original-title="Price"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Price"
                        @keyup="restrictDecimalsAndNumbers($event, market.price_decimals, 'BUY-PRICE')"
                        v-model="globalStore.buyPrice"
                    >
                </div>
                <div class="text-[14px] text-[#2a395a] flex items-center justify-between gap-[10px]">
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(0.25, 'BUY')"
                    >
                        25%
                    </button>
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(0.5, 'BUY')"
                    >
                        50%
                    </button>
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(0.75, 'BUY')"
                    >
                        75%
                    </button>
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(1, 'BUY')"
                    >
                        100%
                    </button>
                </div>
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-2 text-gray-900 border rounded-e-0 border-[#eeeff2] border-e-0 rounded-s-md">
                        {{ toCurrency.slug }} Total
                    </span>
                    <input
                        class="text-[#2a395a] rounded-none rounded-e-lg bg-white border text-right text-[12px] block flex-1 min-w-0 w-full text-sm border-[#eeeff2] p-1.5 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:text-right placeholder:font-[CircularBook]"
                        :placeholder="totalPlaceholder"
                        autocomplete="off"
                        type="text"
                        aria-describedby="BuyTotal"
                        data-original-title="Total"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Total"
                        @keyup="restrictDecimalsAndNumbers($event, market.total_decimals, 'BUY-TOTAL')"
                        v-model="globalStore.buyTotal"
                    >
                </div>
            </div>
        </div>
        <a v-if="userId.length === 0" href="/login" class="flex items-center justify-center gap-[17px] bg-[#366fed] hover:bg-[#5282eb] rounded-[10px] px-2 py-2.5 md:mx-2 xl:mx-0">
            <img src="@/../img/icons/login.svg" alt="">
            <span class="block text-[20px] lg:text-[25px] text-white font-[CircularBook]">Login</span>
        </a>
        <button
            v-if="userId.length > 0"
            class="flex items-center justify-center gap-[17px] bg-[#58bd7d] hover:bg-[#46A56A] rounded-[10px] px-2 py-2.5 xl:mx-0 mt-2 w-full"
            :disabled="openingPosition"
            @click="openPosition('BUY')"
        >
            <img src="@/../img/icons/coin-trade.svg" alt="">
            <span class="block text-[20px] lg:text-[25px] text-white font-[CircularBook]">
                {{ openingPosition ? 'Loading...' : 'BUY' + ' ' + fromCurrency.slug }}
            </span>
        </button>
    </div>
    <div v-if="direction === 'Sell'" class="flex flex-col justify-between h-full">
        <div class="flex-1 bg-white rounded-[15px] overflow-hidden pb-5">
            <div class="border-b border-[#eeeff2] py-3 px-5 mb-3 flex items-center justify-between lg:flex-row flex-col">
                <span class="block text-[20px] font-[CircularBook] text-center">
                    Sell {{ fromCurrency.slug }}
                </span>
                <div>
                    <span class="block text-[12px] text-[#366fed] text-center lg:text-right font-[CircularMedium]">
                        {{ fromCurrencyWallet }} {{ fromCurrency.slug }}
                    </span>
                    <span class="block text-[12px] text-[#a4a6aa] text-center lg:text-right">Available Balance</span>
                </div>
            </div>
            <div class="px-5 py-3 space-y-[10px]">
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-2 text-gray-900 border rounded-e-0 border-[#eeeff2] border-e-0 rounded-s-md">
                        {{ fromCurrency.slug }} Amount
                    </span>
                    <input
                        class="text-[#2a395a] rounded-none rounded-e-lg bg-white border text-right text-[12px] block flex-1 min-w-0 w-full text-sm border-[#eeeff2] p-1.5 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:text-right placeholder:font-[CircularBook]"
                        :placeholder="amountPlaceholder"
                        autocomplete="off"
                        type="text"
                        aria-describedby="sellToUnit"
                        data-original-title="Amount"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Amount"
                        @keyup="restrictDecimalsAndNumbers($event, market.amount_decimals, 'SELL-AMOUNT')"
                        v-model="globalStore.sellAmount"
                    >
                </div>
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-2 text-gray-900 border rounded-e-0 border-[#eeeff2] border-e-0 rounded-s-md">
                        {{ toCurrency.slug }} Price
                    </span>
                    <input
                        class="text-[#2a395a] rounded-none rounded-e-lg bg-white border text-right text-[12px] block flex-1 min-w-0 w-full text-sm border-[#eeeff2] p-1.5 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:text-right placeholder:font-[CircularBook]"
                        :placeholder="pricePlaceholder"
                        autocomplete="off"
                        type="text"
                        aria-describedby="sellToPrice"
                        data-original-title="Price"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Price"
                        @keyup="restrictDecimalsAndNumbers($event, market.price_decimals, 'SELL-PRICE')"
                        v-model="globalStore.sellPrice"
                    >
                </div>
                <div class="text-[14px] text-[#2a395a] flex items-center justify-between gap-[10px]">
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(0.25, 'SELL')"
                    >
                        25%
                    </button>
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(0.5, 'SELL')"
                    >
                        50%
                    </button>
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(0.75, 'SELL')"
                    >
                        75%
                    </button>
                    <button
                        class="text-[12px] xl:text-[14px] border border-[#eeeff2] rounded-[7px] flex items-center justify-center flex-1 px-1 py-1.5 hover:bg-[#e0e8fa] hover:border-[#e0e8fa] transition-all"
                        @click="percentageClick(1, 'SELL')"
                    >
                        100%
                    </button>
                </div>
                <div class="flex">
                    <span class="text-[12px] font-[CircularBook] tracking-wide inline-flex items-center px-2 text-gray-900 border rounded-e-0 border-[#eeeff2] border-e-0 rounded-s-md">
                        {{ toCurrency.slug }} Total
                    </span>
                    <input
                        class="text-[#2a395a] rounded-none rounded-e-lg bg-white border text-right text-[12px] block flex-1 min-w-0 w-full text-sm border-[#eeeff2] p-1.5 placeholder:text-[12px] placeholder:text-[#a4a6aa] placeholder:text-right placeholder:font-[CircularBook]"
                        :placeholder="totalPlaceholder"
                        autocomplete="off"
                        type="text"
                        aria-describedby="SellTotal"
                        data-original-title="Total"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Total"
                        @keyup="restrictDecimalsAndNumbers($event, market.total_decimals, 'SELL-TOTAL')"
                        v-model="globalStore.sellTotal"
                    >
                </div>
            </div>
        </div>
        <a v-if="userId.length === 0" href="/register" class="flex items-center justify-center gap-[17px] bg-[#366fed] hover:bg-[#5282eb] rounded-[10px] px-2 py-2.5 md:mx-2 xl:mx-0">
            <img src="@/../img/icons/user-plus.svg" alt="">
            <span class="block text-[20px] lg:text-[25px] text-white font-[CircularBook]">Register Now</span>
        </a>
        <button
            v-if="userId.length > 0"
            class="flex items-center justify-center gap-[17px] bg-[#cf3d3d] hover:bg-[#B23232] rounded-[10px] px-2 py-2.5 xl:mx-0 mt-2 w-full"
            :disabled="openingPosition"
            @click="openPosition('SELL')"
        >
            <img src="@/../img/icons/coin-trade.svg" alt="">
            <span class="block text-[20px] lg:text-[25px] text-white font-[CircularBook]">
                {{ openingPosition ? 'Loading...' : 'SELL' + ' ' + fromCurrency.slug }}
            </span>
        </button>
    </div>
</template>

